module.exports = __webpack_public_path__ + "asset/resolution-register-form--f08c12.png";